import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_SSR_CACHE_LIFETIME_SECONDS_OVERRIDE = createFcmDetails(
	'corgi_ssr_cache_lifetime_seconds_override',
	{
		owner: 'FE framework squad',
		context: 'corgi SSR',
		import: false,
		description: `Used to override the default server caching lifetime (default it 1 minute).
			Each property should match the route's id in corgi for which the cache lifetime should be overridden.
			Values should be in seconds.`,
		template: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'route-id': 120,
		},
	},
);
